<script setup>
import { router, Head, Link, useForm } from '@inertiajs/vue3';
import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';
import AppLayout from '@/Layouts/AppLayout.vue';

const props = defineProps({
    data: Object,
    loggedInUser: Object,
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

let pageTitle = props.data.page.title;
let pageContent = props.data.page.content;

if (pageTitle.constructor.name != 'Object') {
    pageTitle = JSON.parse(pageTitle);
}

if (pageContent.constructor.name != 'Object') {
    pageContent = JSON.parse(pageContent);
}


</script>

<template>
    <!-- <AppTheming v-if="!props.loggedInUser"/> -->

    <Head title="Programme" />

    <AppLayout title="Page">
        <div :id="!props.loggedInUser? 'content-wrapper' : 'content-wrapper-unstyled'">
            <div id="main-content" class="container mx-auto flex flex-col md:flex-row justify-between w-full pt-5 pb-5">
            <!-- <div class="container mx-auto flex flex-col lg:flex-row justify-between w-full"> -->

                <div v-if="props.loggedInUser" id="sos-programme-dashboard-sidebar" class="order-2 lg:order-1 w-full lg:w-1/4 xl:w-1/5 min-h-screen p-10 pt-5">
                    <DashboardSidebar />
                </div>

                <div class="order-1 lg:order-2 w-full lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content sos-programme-custom-page-content">
                    <div class="overflow-hidden pl-10 mb-10 pr-10 lg:pr-0 pt-3">
                        <div id="toolkit-header" class="md:flex">
                            <div class="md:basis-1/2">
                                <h1 class="dashboard-title pt-5">{{ pageTitle[$i18n.locale] ? pageTitle[$i18n.locale] : pageTitle[$i18n.fallbackLocale] }}</h1>
                            </div>
                        </div>
                        <div v-html="pageContent[$i18n.locale] ? pageContent[$i18n.locale] : pageContent[$i18n.fallbackLocale]"></div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
